import React from "react";
import { Field, Label, Row, StyledErrorMessage, Input } from "./styles";
import { Controller } from "react-hook-form";
import { Role } from "@teamrota/authlib";
import useAuth from "~/src/auth/hooks/use-auth";
import MemberStateInput from "./member-state-input";
import { RotaSwitch } from "@teamrota/rota-design";

const AdditionalInformation = ({
  errors,
  register,
  control,
  upcomingBookingsCount,
  inEditMode,
  setMemberState,
  memberState,
  isRightToWorkValid,
  initialValues,
  isAllowedToViewMemberDetails
}) => {
  const auth = useAuth();
  const isAllowedToViewMemberState = auth.hasRole(Role.MEMBERS_STATE);

  return (
    <div style={{ marginTop: "20px" }}>
      <Row>
        {isAllowedToViewMemberState && (
          <Field>
            <Label>Member state</Label>
            <MemberStateInput
              upcomingBookingsCount={upcomingBookingsCount}
              inEditMode={
                auth.hasRole(Role.MEMBERS_STATE_EDIT) ? inEditMode : false
              }
              setMemberState={setMemberState}
              memberState={memberState}
              isRightToWorkValid={isRightToWorkValid}
            />
            <StyledErrorMessage>
              {errors.memberState?.message}
            </StyledErrorMessage>
          </Field>
        )}
        {isAllowedToViewMemberDetails && (
          <Field>
            <Controller
              control={control}
              {...register("isEligibleForRebook")}
              render={({ field }) => (
                <RotaSwitch
                  checked={field.value}
                  onChange={checked => field.onChange(checked)}
                  label={"Eligible for rebook"}
                  disabled={!inEditMode}
                />
              )}
            />
            <StyledErrorMessage>{errors.notes?.message}</StyledErrorMessage>
          </Field>
        )}
      </Row>
      <Field>
        <Label>Internal staff ID</Label>
        <Input
          {...register("internalId")}
          placeholder={initialValues?.internalId}
          disabled={!inEditMode}
        />
        <StyledErrorMessage>{errors.internalId?.message}</StyledErrorMessage>
      </Field>
    </div>
  );
};
export default AdditionalInformation;
